import React, { FC, HTMLAttributes, useMemo } from "react";
import styles from "./SnsShareArea.module.css";

export type Props = HTMLAttributes<HTMLDivElement> & {
  slug: string;
  title: string;
  twitterHashtags: (string | null)[];
};
const SnsShareArea: FC<Props> = ({ slug, title, twitterHashtags }) => {
  const projectUrl = useMemo(() => `${process.env.API_CF_BASE_URL}/project/${slug}`, [slug]);
  const twitterUrl = useMemo(() => {
    const url = new URL("https://twitter.com/intent/tweet");
    url.searchParams.append("text", title);
    url.searchParams.append("url", projectUrl);
    url.searchParams.append("hashtags", twitterHashtags.filter((hashtag) => !!hashtag).join(","));
    return url.toString();
  }, [projectUrl]);
  const facebookUrl = useMemo(() => {
    const url = new URL("https://www.facebook.com/sharer/sharer.php");
    url.searchParams.append("u", projectUrl);
    return url.toString();
  }, [projectUrl]);
  const lineUrl = useMemo(() => {
    const url = new URL("https://line.me/R/share");
    url.searchParams.append("text", `${title.replace(" ", "")}\n${projectUrl}`);
    return url.toString();
  }, [projectUrl]);
  return (
    <div className={styles.root}>
      <a href={twitterUrl} target="_blank" rel="noreferrer">
        <div className={styles.twitter}>
          <img src="/img/sns/twitter_logo.svg" width="24" height="24" decoding="async" loading="lazy" />
        </div>
      </a>
      <a href={facebookUrl} target="_blank" rel="noreferrer">
        <div className={styles.facebook}>
          <img src="/img/sns/facebook_logo.svg" width="34" height="34" decoding="async" loading="lazy" />
        </div>
      </a>
      <a href={lineUrl} target="_blank" rel="noreferrer">
        <div className={styles.line}>
          <img src="/img/sns/line_logo.svg" width="26" height="26" decoding="async" loading="lazy" />
        </div>
      </a>
    </div>
  );
};
export default SnsShareArea;
